import React from "react";

import sanitizeHTML from "sanitize-html";

const SUPPORTED_SANITIZER_OPTIONS = [
  "allowProtocolRelative",
  "allowedAttributes",
  "allowedClasses",
  "allowedSchemes",
  "allowedSchemesByTag",
  "allowedTags",
  "exclusiveFilter",
  "nonTextTags",
  "parser",
  "selfClosing",
  "transformTags"
];

type SanitizedHTMLProps = {
  allowProtocolRelative?: boolean;
  allowedAttributes?: Record<string, string[]>;
  allowedClasses?: Record<string, string[]>;
  allowedSchemes?: string[];
  allowedSchemesByTag?: Record<string, string[]>;
  allowedTags?: string[];
  exclusiveFilter?: () => void;
  html: string;
  nonTextTags?: string[];
  parser?: unknown;
  selfClosing?: string[];
  transformTags?: Record<string, string | (() => void)>;
  id?: string;
  style?: Record<string, string | number>;
  className?: string;
};

const SanitizedHTML = (props: SanitizedHTMLProps) => {
  const sanitizerOptions: Record<string, SanitizedHTMLProps> =
    SUPPORTED_SANITIZER_OPTIONS.reduce((options, name) => {
      const value = props[name];

      if (typeof value !== "undefined") {
        options[name] = value;
      }

      return options;
    }, {});

  const sanitizedHTML = sanitizeHTML(props.html ?? "", sanitizerOptions);

  return (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
      id={props.id}
      style={props.style}
      className={props.className}
    />
  );
};

export default SanitizedHTML;
